// After an iframe reload (the VIO host reloads it on token rotation) a prize
// won a moment ago must still be shown. Rewards already presented in this tab
// are remembered per member so they are not shown twice.

export const RECENT_WIN_WINDOW_MS = 3 * 60 * 1000;
const KEY = (userId) => `vio:shake:pwa:seenWins:${userId}`;
const memory = new Map();

function readSeen(userId) {
  try {
    const raw = sessionStorage.getItem(KEY(userId));
    return raw ? JSON.parse(raw) : [];
  } catch (_) {
    return memory.get(userId) || [];
  }
}

export function markRewardSeen(userId, rewardId) {
  if (!userId || !rewardId) return;
  const seen = [String(rewardId), ...readSeen(userId).filter((id) => id !== String(rewardId))].slice(0, 20);
  memory.set(userId, seen);
  try {
    sessionStorage.setItem(KEY(userId), JSON.stringify(seen));
  } catch (_) {
    // storage blocked: memory only
  }
}

/** Newest reward won within the window and not yet presented, else null. */
export function pickUnseenRecentWin(rewards, userId, now = Date.now()) {
  if (!userId || !Array.isArray(rewards)) return null;
  const seen = new Set(readSeen(userId));
  const recent = rewards
    .filter((r) => {
      const at = new Date(r.createdAt).getTime();
      return Number.isFinite(at) && now - at <= RECENT_WIN_WINDOW_MS && now - at >= -60 * 1000;
    })
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  const latest = recent[0];
  return latest && !seen.has(String(latest.id)) ? latest : null;
}
